import { render, staticRenderFns } from "./SampleTransit.vue?vue&type=template&id=64298626&scoped=true"
import script from "./SampleTransit.vue?vue&type=script&lang=js"
export * from "./SampleTransit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64298626",
  null
  
)

export default component.exports